// import { AddRounded } from "@mui/icons-material";
// import { Button } from "@mui/material";
// import { useNavigate } from "react-router-dom";

// const CreateLoanButton = ({ size = "small" }) => {
//   const navigate = useNavigate();
//   return (
//     <Button
//       startIcon={<AddRounded />}
//       size={size}
//       onClick={() => navigate("/loan/create")}
//     >
//       Create Loan
//     </Button>
//   );
// };

// export default CreateLoanButton;

import {
  AddRounded,
  ArrowDropDownRounded,
  FileUploadOutlined,
  ImportContacts,
  ImportExportOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEnv } from "../../../hooks/useEnv";

const options = [
  {
    label: "Create New Loan",
    path: "/loan/create",
    icon: <AddRounded className="thin" />,
  },
  {
    label: "Create Loan From Loan Application PDF",
    // label: "Create Loan from Loan App PDF",
    icon: <FileUploadOutlined className="thin" />,
    // label: "Import & Create Loan from Loan App PDF",
    path: "/loan/create/import",
  },
];

const CreateLoanButton = ({ size = "small" }) => {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { isResfin } = useEnv();
  if (!isResfin) {
    return (
      <Button
        variant="contained"
        size="medium"
        // startIcon={<AddRounded className="thin" />}
        onClick={() => navigate("/loan/create")}
      >
        Create Loan
      </Button>
    );
  }
  return (
    <>
      <ButtonGroup variant="inherit" size={size} ref={anchorRef}>
        <Button
          variant="contained"
          // startIcon={<AddRounded className="thin" />}
          onClick={() => navigate(options[0].path)}
        >
          Create Loan
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => setOpen((prev) => !prev)}
          sx={{
            px: 0.15,
            minWidth: "28px !important",
            //
            borderLeft: `1px solid ${blue[900]}`,
            // borderLeft: "1px solid #ffffff",
          }}
        >
          <ArrowDropDownRounded />
        </Button>
      </ButtonGroup>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-end"
        sx={{ zIndex: 1300 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper elevation={4}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList autoFocusItem>
                  {options.map((option) => (
                    <MenuItem
                      key={option.path}
                      sx={{
                        fontSize: "12px",
                        svg: {
                          fontSize: "16px",
                          mr: 1,
                        },
                      }}
                      onClick={() => {
                        setOpen(false);
                        navigate(option.path);
                      }}
                    >
                      {option.icon}
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default CreateLoanButton;
